module.exports = __webpack_public_path__ + "media/img/decorations/our-work-left-8eb708b5a2878baef4aea7832d4055cc.svg";